import { useState } from 'react';

export default function useSetState(initialState) {
  const [currentState, setCurrentState] = useState(initialState);

  const setState = patch =>
    typeof patch === 'function'
      ? setCurrentState(prevState => ({ ...prevState, ...patch(prevState) }))
      : setCurrentState({ ...currentState, ...patch });

  return [currentState, setState];
}



// WEBPACK FOOTER //
// ./src/hooks/useSetState.js